var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { attrs: { shadow: "never", bordered: false } },
        [
          _c(
            "el-form",
            {
              attrs: { inline: "", size: "small" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "我方订单号" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "CH 开头" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.loadList(1)
                      },
                    },
                    model: {
                      value: _vm.query.orderNo,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "orderNo",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.orderNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "第三方订单号" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入订单号" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.loadList(1)
                      },
                    },
                    model: {
                      value: _vm.query.outOrderNo,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.query,
                          "outOrderNo",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "query.outOrderNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "全部" },
                      on: {
                        change: function ($event) {
                          return _vm.loadList(1)
                        },
                      },
                      model: {
                        value: _vm.query.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "status", $$v)
                        },
                        expression: "query.status",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "待发货", value: 0 } }),
                      _c("el-option", {
                        attrs: { label: "仓库处理中", value: 1 },
                      }),
                      _c("el-option", { attrs: { label: "已发货", value: 2 } }),
                      _c("el-option", { attrs: { label: "已取消", value: 3 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.loadList(1)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.reset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "mt14", attrs: { shadow: "never", bordered: false } },
        [
          _c("el-alert", {
            attrs: {
              title:
                "私域渠道订单由平台仓库负责导入和发货，商户端仅展示本商户的订单及物流状态。",
              type: "info",
              closable: false,
              "show-icon": "",
            },
          }),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "mt20",
              attrs: { data: _vm.list, border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "序号", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "我方订单号",
                  "min-width": "165",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "outOrderNo",
                  label: "第三方订单号",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "channelName",
                  label: "渠道",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "收货人", "min-width": "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(_vm._s(scope.row.realName || "-")),
                        _c("br"),
                        _c("span", { staticClass: "muted" }, [
                          _vm._v(_vm._s(scope.row.userPhone || "")),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "totalNum", label: "件数", width: "70" },
              }),
              _c("el-table-column", {
                attrs: { prop: "totalPrice", label: "金额", width: "95" },
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "95" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.statusType(scope.row.status),
                            },
                          },
                          [_vm._v(_vm._s(_vm.statusText(scope.row.status)))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "expressNo",
                  label: "运单号",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "shipTime",
                  label: "发货时间",
                  "min-width": "160",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "80", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.showDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.query.page,
                  "page-size": _vm.query.limit,
                  "page-sizes": [10, 20, 50],
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.changeSize,
                  "current-change": _vm.loadList,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "渠道订单详情",
            visible: _vm.detailVisible,
            width: "720px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _vm.detail
            ? _c(
                "el-descriptions",
                { attrs: { column: 2, border: "", size: "small" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "我方订单号" } },
                    [_vm._v(_vm._s(_vm.detail.orderNo))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "第三方订单号" } },
                    [_vm._v(_vm._s(_vm.detail.outOrderNo))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "渠道" } }, [
                    _vm._v(_vm._s(_vm.detail.channelName || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "收货人" } }, [
                    _vm._v(
                      _vm._s(_vm.detail.realName) +
                        " " +
                        _vm._s(_vm.detail.userPhone)
                    ),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "地址", span: 2 } },
                    [_vm._v(_vm._s(_vm.address(_vm.detail)))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "运单号" } }, [
                    _vm._v(_vm._s(_vm.detail.expressNo || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "备注" } }, [
                    _vm._v(_vm._s(_vm.detail.remark || "-")),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.detail && _vm.detail.items
            ? _c(
                "el-table",
                {
                  staticClass: "mt14",
                  attrs: { data: _vm.detail.items, border: "", size: "small" },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "序号", width: "60", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [_vm._v(_vm._s(_vm.$pageIndex(scope)))]
                          },
                        },
                      ],
                      null,
                      false,
                      3594593631
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "productName",
                      label: "商品",
                      "min-width": "190",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "sourceProductName",
                      label: "来源/店铺",
                      "min-width": "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "sku", label: "规格", "min-width": "130" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "num", label: "数量", width: "70" },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }